export enum appAccessOptionsUserRoles {
    WILDMARKE = "wildmarke",
    MAP = "smartmap",
    WILDKAMMER = "wildkammer",
    COKCPIT = "cockpit",
    ANSTELLER = "ansteller",
    BERGEN = "bergen",
    ASPHILFE = "asphilfe",
    ADMIN = "admin",
  }
  
  export const rightsUserRoles = [
    {
      right: "nachrichten",
      name: "RIGHTS.nachrichten"
    },
    {
      right: "scan",
      name: "RIGHTS.scan"
    },
    {
      right: "jagdKontext",
      name: "RIGHTS.jagdKontext"
    },
    {
      right: "drueckJagd",
      name: "RIGHTS.drueckJagd"
    },
    {
      right: "drueckJagdLeitung",
      name: "RIGHTS.drueckJagdLeitung"
    },
    {
      right: "archiv",
      name: "RIGHTS.archiv"
    },
    {
      right: "konto",
      name: "RIGHTS.konto"
    },
    {
      right: "entwickler",
      name: "RIGHTS.entwickler"
    },
    {
      right: "wimareg",
      name: "RIGHTS.wimareg"
    },
    {
      right: "dokumente",
      name: "RIGHTS.dokumente"
    },    
    {
      right: "nachsuche",
      name: "RIGHTS.nachsuche"
    },    
    {
      right: "wimareg",
      name: "RIGHTS.wimareg"
    },    
    {
      right: "debug",
      name: "RIGHTS.debug"
    },    
    {
      right: "info",
      name: "RIGHTS.info"
    },    
    {
      right: "dashboard",
      name: "RIGHTS.dashboard"
    },    
    {
      right: "captureGame",
      name: "RIGHTS.captureGame"
    },    
    {
      right: "gameList",
      name: "RIGHTS.gameList"
    },
    {
      right: "gameListOwnGame",
      name: "RIGHTS.gameListOwnGame"
    },    
    {
      right: "exportGameList",
      name: "RIGHTS.exportGameList"
    },    
    {
      right: "revierManagement",
      name: "RIGHTS.revierManagement"
    },    
    {
      right: "aktuelleWildmarken",
      name: "RIGHTS.aktuelleWildmarken"
    },    
    {
      right: "manageDigaTags",
      name: "RIGHTS.manageDigaTags"
    },    
    {
      right: "seeGeoPoints",
      name: "RIGHTS.seeGeoPoints"
    },    
    {
      right: "manageGeoPoints",
      name: "RIGHTS.manageGeoPoints"
    },    
    {
      right: "importGeoObjects",
      name: "RIGHTS.importGeoObjects"
    },    
    {
      right: "exportGeoObjects",
      name: "RIGHTS.exportGeoObjects"
    },    
    {
      right: "viewTransactionLog",
      name: "RIGHTS.viewTransactionLog"
    },    
    {
      right: "wildmarke",
      name: "RIGHTS.wildmarke"
    },
    {
      right: "smartmap",
      name: "RIGHTS.smartmap"
    },
    {
      right: "cockpit",
      name: "RIGHTS.cokcpit"
    },
    {
      right: "ansteller",
      name: "RIGHTS.ansteller"
    },
    {
      right: "bergen",
      name: "RIGHTS.bergen"
    },
    {
      right: "asphilfe",
      name: "RIGHTS.asphilfe"
    },
    {
      right: "admin",
      name: "RIGHTS.admin"
    },
    {
      right: "_debugging",
      name: "RIGHTS._debugging"
    },
    {
      right: "_support",
      name: "RIGHTS._support"
    },
    {
      right: "_allGame",
      name: "RIGHTS._allGame"
    },
  ]

  
  export function rights(self:string) {
    switch (self) {
        case 'admin': return allCases;
        case 'ansteller': return ["nachrichten", "drueckJagd", "captureGame", "gameList", "ansteller", "seeGeoPoints", "bergen"]
        case 'jagdleiter': return ["nachrichten", "aktuelleWildmarken", "drueckJagd", "drueckJagdLeitung", "dashboard", "captureGame", "gameList", "seeGeoPoints", "ansteller", "smartmap", "bergen", "wildkammer", "wildmarke", "dashboard", "exportGameList", "viewTransactionLog"]
        case 'user': return defaultRights
        case 'hunter': return ["nachrichten", "aktuelleWildmarken", "jagdKontext", "captureGame", "gameList", "seeGeoPoints", "wildmarke", "wildkammer", "dashboard", "smartmap", "bergen"]
        case 'revierLeiter': return ["nachrichten", "aktuelleWildmarken", "revierManagement", "captureGame", "gameList", "cockpit", "ansteller", "smartmap", "bergen", "wildkammer", "wildmarke", "dashboard", "exportGameList", "viewTransactionLog", "seeGeoPoints", "manageGeoPoints"]
        case 'recorder': return  ["gameListOwnGame", "seeGeoPoints", "captureGame", "wildmarke"]
        case 'wsvgKadaverSucher': return ["nachrichten", "drueckJagd", "captureGame", "gameList", "seeGeoPoints", "ansteller", "bergen"]
        case 'wsvgKadaverBergeTeam': return ["nachrichten", "drueckJagd", "captureGame", "gameList", "seeGeoPoints", "ansteller", "bergen"]
        case 'wsvgSonstigerMitarbeiter': return ["nachrichten", "drueckJagd", "captureGame", "gameList", "ansteller", "seeGeoPoints", "smartmap", "bergen"]
        case 'wsvgLeitenderMitarbeiter': return ["nachrichten", "drueckJagd", "captureGame", "gameList", "ansteller", "seeGeoPoints", "manageGeoPoints", "smartmap", "bergen"]
        case 'applicantVet': return  ["gameListOwnGame", "seeGeoPoints", "captureGame", "wildmarke"]
        case 'veterinaryHuntingDistrictLeader': return ["gameList", "seeGeoPoints", "captureGame", "wildmarke", "revierManagement"]
    }
  }
  

  export var defaultRights = ["nachrichten", "scan", "konto", "entwickler", "info", "wildmarke", "dashboard", "asphilfe"]

  export var allCases = [
        "admin",
        "revierLeiter",
        "jagdleiter",
        "hunter",
        "user",
        "ansteller",
        "recorder",
        "applicantVet",
        "veterinaryHuntingDistrictLeader"
    ]
    // if SharedDataManager._shared.hasModule(named: "diwima-adis") {
    //     return allCases + [.wsvgKadaverSucher, .wsvgKadaverBergeTeam, .wsvgSonstigerMitarbeiter, .wsvgLeitenderMitarbeiter]
    // } else {
    //     return allCases
    // }

    export var allCases_diwima_adis = [
        "admin",
        "revierLeiter",
        "jagdleiter",
        "hunter",
        "user",
        "ansteller",
        "recorder",
        "applicantVet",
        "veterinaryHuntingDistrictLeader",
        "wsvgKadaverSucher", 
        "wsvgKadaverBergeTeam",
        "wsvgSonstigerMitarbeiter",
        "wsvgLeitenderMitarbeiter"
    ]
  
  export const appAccessOptionsUserRolesData =  [
    {
      type: "wildmarke",
      translate: "user_roles.appAccess.wildmarke"
    },
    {
      type: "smartmap",
      translate: "user_roles.appAccess.smartmap"
    },
    {
      type: "wildkammer",
      translate: "user_roles.appAccess.wildkammer"
    },
    {
      type: "cockpit",
      translate: "user_roles.appAccess.cockpit"
    },
    {
      type: "ansteller",
      translate: "user_roles.appAccess.ansteller"
    },
    {
      type: "bergen",
      translate: "user_roles.appAccess.bergen"
    },
    // {
    //   type: "asphilfe",
    //   translate: "user_roles.appAccess.asphilfe"
    // },
    // {
    //   type: "admin",
    //   translate: "user_roles.appAccess.admin"
    // },
  ]
  
  export const rightsOptionsUserRolesData =  [
    {
      type: "create",
      translate: "user_roles.rights.create",
      only: ['PointOfInterest', 'WorkOrder', 'GameRecord', 'HuntingDistrict', 'Person', 'LaboratorySample', 'User', 'Context/Settings']
    },
    {
      type: "read",
      translate: "user_roles.rights.read",
      only: ['PointOfInterest', 'WorkOrder', 'GameRecord', 'HuntingDistrict', 'Person', 'LaboratorySample', 'User', 'Context/Settings']
    },
    {
      type: "update",
      translate: "user_roles.rights.update",
      only: ['PointOfInterest', 'WorkOrder', 'GameRecord', 'HuntingDistrict', 'Person', 'LaboratorySample', 'User', 'Context/Settings']
    },
    {
      type: "delete",
      translate: "user_roles.rights.delete",
      only: ['PointOfInterest', 'WorkOrder', 'GameRecord', 'HuntingDistrict', 'Person', 'LaboratorySample', 'User', 'Context/Settings']
    },
    {
      type: "export",
      translate: "user_roles.rights.export",
      only: ['PointOfInterest', 'HuntingDistrict', 'GameRecord']
    },
    {
      type: "import",
      translate: "user_roles.rights.import",
      only: ['PointOfInterest', 'HuntingDistrict']
    },
    {
      type: "multiEdit",
      translate: "user_roles.rights.multiEdit",
      only: ['PointOfInterest', 'GameRecord']
    },
  ]
  
  export const filtersOptionsUserRolesData =  [
    {
      type: "createdByUser",
      translate: "user_roles.filters.createdByUser",
      only: ['GameRecord'],
      title: undefined
    },
    {
      type: "createdByUser",
      translate: "user_roles.filters.createdByUser",
      only: ['WorkOrder'],
      title: undefined
    },
    {
      type: "createdByUser",
      translate: "user_roles.filters.createdByUser",
      only: ['LaboratorySample'],
      title: undefined
    },
    {
      type: "sameUserGroup",
      translate: "user_roles.filters.sameUserGroup",
      only: ['User'],
      title: undefined
    },
    {
      type: "sameRoles",
      translate: "user_roles.filters.sameRoles",
      only: ['User'],
      title: undefined
    },
    {
      type: "assignedToUser",
      translate: "user_roles.filters.assignedToUser",
      only: ['WorkOrder'],
      title: undefined
    },
    {
      type: "notAssigned",
      translate: "user_roles.filters.notAssigned",
      only: ['WorkOrder'],
      title: undefined
    },
  
    {
      type: "withoutCategory",
      translate: "user_roles.filters.withoutCategory",
      only: ['PointOfInterest'],
      title: undefined
    },
    {
      type: "linkedInWorkOrders",
      translate: "user_roles.filters.linkedInWorkOrders",
      only: ['PointOfInterest'],
      title: undefined
    },
    // {
    //   type: "<category-name>",
    //   translate: "user_roles.filters.withoutCategory",
    //   only: ['PointOfInterest']
    // }
  ]